import React, { useEffect, useState } from 'react';
import { IconButton } from '@lmt/unicorn-shared/app/components/common/ui-kit/IconButton';

interface Props {
  text: string;
  showTip: () => void;
  hideTip: () => void;
}

import styles from '@lmt/unicorn-shared/src/app/components/common/ui-kit/configuration/SettingsTip.module.scss';
import CloseIcon from '@lmt/unicorn-shared/app/icons/close.svg?react';

export const SettingsTip: React.FC<Props> = (props) => {
  const [isShowing, setShowing] = useState<boolean>(true);

  useEffect(() => {
    props.showTip();
  }, []);

  if (!isShowing) {
    return null;
  }

  return (
    <div className={styles.container}>
      {props.text}
      <IconButton
        className={styles.iconButton}
        iconComponent={<CloseIcon className={styles.icon} />}
        onClick={() => {
          props.hideTip();
          setShowing(false);
        }}
      />
    </div>
  );
};
